// @ts-nocheck 
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.8.0 (NJsonSchema v11.0.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import {ApiClientConfig} from "app/modules/common/api/ApiClientConfig";
import {AuthorizedApiBase} from "app/modules/common/api/AuthorizedApiBase";import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import moment from 'moment';

export interface IExternalOrderLinkClient {
    getOrderInfo(link: string): Promise<OrderExternalViewModel>;
}

export class ExternalOrderLinkClient extends AuthorizedApiBase implements IExternalOrderLinkClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getOrderInfo(link: string, signal?: AbortSignal): Promise<OrderExternalViewModel> {
        let url_ = this.baseUrl + "/external/GetOrderInfo/{link}";
        if (link === undefined || link === null)
            throw new Error("The parameter 'link' must be defined.");
        url_ = url_.replace("{link}", encodeURIComponent("" + link));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderInfo(_response);
        });
    }

    protected processGetOrderInfo(response: AxiosResponse): Promise<OrderExternalViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderExternalViewModel.fromJS(resultData200);
            return Promise.resolve<OrderExternalViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderExternalViewModel>(null as any);
    }
}

export interface ISalesClient {
    submitEnquiry(phone: string | null | undefined, email: string | null | undefined, fullName: string | null | undefined, text: string | null | undefined, captchaToken: string | null | undefined): Promise<void>;
}

export class SalesClient extends AuthorizedApiBase implements ISalesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    submitEnquiry(phone: string | null | undefined, email: string | null | undefined, fullName: string | null | undefined, text: string | null | undefined, captchaToken: string | null | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/sales/SubmitEnquiry?";
        if (phone !== undefined && phone !== null)
            url_ += "phone=" + encodeURIComponent("" + phone) + "&";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (fullName !== undefined && fullName !== null)
            url_ += "fullName=" + encodeURIComponent("" + fullName) + "&";
        if (text !== undefined && text !== null)
            url_ += "text=" + encodeURIComponent("" + text) + "&";
        if (captchaToken !== undefined && captchaToken !== null)
            url_ += "captchaToken=" + encodeURIComponent("" + captchaToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmitEnquiry(_response);
        });
    }

    protected processSubmitEnquiry(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class OrderExternalViewModel implements IOrderExternalViewModel {
    id?: number;
    orderNo?: string | undefined;
    vehicle?: string | undefined;
    vehicleLocation?: string | undefined;
    displayLocation?: string | undefined;
    drivers?: OrderDriverViewModel[] | undefined;
    stops?: OrderStopViewModel[] | undefined;
    status?: OrderStatus;

    constructor(data?: IOrderExternalViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.orderNo = _data["OrderNo"];
            this.vehicle = _data["Vehicle"];
            this.vehicleLocation = _data["VehicleLocation"];
            this.displayLocation = _data["DisplayLocation"];
            if (Array.isArray(_data["Drivers"])) {
                this.drivers = [] as any;
                for (let item of _data["Drivers"])
                    this.drivers!.push(OrderDriverViewModel.fromJS(item));
            }
            if (Array.isArray(_data["Stops"])) {
                this.stops = [] as any;
                for (let item of _data["Stops"])
                    this.stops!.push(OrderStopViewModel.fromJS(item));
            }
            this.status = _data["Status"];
        }
    }

    static fromJS(data: any): OrderExternalViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderExternalViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["OrderNo"] = this.orderNo;
        data["Vehicle"] = this.vehicle;
        data["VehicleLocation"] = this.vehicleLocation;
        data["DisplayLocation"] = this.displayLocation;
        if (Array.isArray(this.drivers)) {
            data["Drivers"] = [];
            for (let item of this.drivers)
                data["Drivers"].push(item.toJSON());
        }
        if (Array.isArray(this.stops)) {
            data["Stops"] = [];
            for (let item of this.stops)
                data["Stops"].push(item.toJSON());
        }
        data["Status"] = this.status;
        return data;
    }

    clone(): OrderExternalViewModel {
        const json = this.toJSON();
        let result = new OrderExternalViewModel();
        result.init(json);
        return result;
    }
}

export interface IOrderExternalViewModel {
    id?: number;
    orderNo?: string | undefined;
    vehicle?: string | undefined;
    vehicleLocation?: string | undefined;
    displayLocation?: string | undefined;
    drivers?: OrderDriverViewModel[] | undefined;
    stops?: OrderStopViewModel[] | undefined;
    status?: OrderStatus;
}

export class OrderDriverViewModel implements IOrderDriverViewModel {
    fullName?: string | undefined;
    carrier?: string | undefined;
    phone?: string | undefined;

    constructor(data?: IOrderDriverViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["FullName"];
            this.carrier = _data["Carrier"];
            this.phone = _data["Phone"];
        }
    }

    static fromJS(data: any): OrderDriverViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDriverViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FullName"] = this.fullName;
        data["Carrier"] = this.carrier;
        data["Phone"] = this.phone;
        return data;
    }

    clone(): OrderDriverViewModel {
        const json = this.toJSON();
        let result = new OrderDriverViewModel();
        result.init(json);
        return result;
    }
}

export interface IOrderDriverViewModel {
    fullName?: string | undefined;
    carrier?: string | undefined;
    phone?: string | undefined;
}

export class OrderStopEditModel implements IOrderStopEditModel {
    id?: number;
    orderStopAddressId?: number | undefined;
    type?: OrderStopType;
    date?: moment.Moment;
    isDirectOrASAP?: boolean;
    pOCName?: string | undefined;
    pOCPhone?: string | undefined;
    arrived?: moment.Moment | undefined;
    departed?: moment.Moment | undefined;
    description?: string | undefined;
    dateEnd?: moment.Moment | undefined;

    constructor(data?: IOrderStopEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.orderStopAddressId = _data["OrderStopAddressId"];
            this.type = _data["Type"];
            this.date = _data["Date"] ? moment(_data["Date"].toString()) : <any>undefined;
            this.isDirectOrASAP = _data["IsDirectOrASAP"];
            this.pOCName = _data["POCName"];
            this.pOCPhone = _data["POCPhone"];
            this.arrived = _data["Arrived"] ? moment(_data["Arrived"].toString()) : <any>undefined;
            this.departed = _data["Departed"] ? moment(_data["Departed"].toString()) : <any>undefined;
            this.description = _data["Description"];
            this.dateEnd = _data["DateEnd"] ? moment(_data["DateEnd"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OrderStopEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderStopEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["OrderStopAddressId"] = this.orderStopAddressId;
        data["Type"] = this.type;
        data["Date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["IsDirectOrASAP"] = this.isDirectOrASAP;
        data["POCName"] = this.pOCName;
        data["POCPhone"] = this.pOCPhone;
        data["Arrived"] = this.arrived ? this.arrived.toISOString() : <any>undefined;
        data["Departed"] = this.departed ? this.departed.toISOString() : <any>undefined;
        data["Description"] = this.description;
        data["DateEnd"] = this.dateEnd ? this.dateEnd.toISOString() : <any>undefined;
        return data;
    }

    clone(): OrderStopEditModel {
        const json = this.toJSON();
        let result = new OrderStopEditModel();
        result.init(json);
        return result;
    }
}

export interface IOrderStopEditModel {
    id?: number;
    orderStopAddressId?: number | undefined;
    type?: OrderStopType;
    date?: moment.Moment;
    isDirectOrASAP?: boolean;
    pOCName?: string | undefined;
    pOCPhone?: string | undefined;
    arrived?: moment.Moment | undefined;
    departed?: moment.Moment | undefined;
    description?: string | undefined;
    dateEnd?: moment.Moment | undefined;
}

export class OrderStopViewModel extends OrderStopEditModel implements IOrderStopViewModel {
    fullAddress?: string | undefined;
    name?: string | undefined;
    address?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipCode?: string | undefined;
    country?: string | undefined;
    addressNote?: string | undefined;

    constructor(data?: IOrderStopViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fullAddress = _data["FullAddress"];
            this.name = _data["Name"];
            this.address = _data["Address"];
            this.address2 = _data["Address2"];
            this.city = _data["City"];
            this.state = _data["State"];
            this.zipCode = _data["ZipCode"];
            this.country = _data["Country"];
            this.addressNote = _data["AddressNote"];
        }
    }

    static override fromJS(data: any): OrderStopViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderStopViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FullAddress"] = this.fullAddress;
        data["Name"] = this.name;
        data["Address"] = this.address;
        data["Address2"] = this.address2;
        data["City"] = this.city;
        data["State"] = this.state;
        data["ZipCode"] = this.zipCode;
        data["Country"] = this.country;
        data["AddressNote"] = this.addressNote;
        super.toJSON(data);
        return data;
    }

    clone(): OrderStopViewModel {
        const json = this.toJSON();
        let result = new OrderStopViewModel();
        result.init(json);
        return result;
    }
}

export interface IOrderStopViewModel extends IOrderStopEditModel {
    fullAddress?: string | undefined;
    name?: string | undefined;
    address?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipCode?: string | undefined;
    country?: string | undefined;
    addressNote?: string | undefined;
}

/** 1 = Shipper 2 = Consignee */
export enum OrderStopType {
    Shipper = 1,
    Consignee = 2,
}

/** 1 = Draft 2 = Ready 3 = InProgress 4 = Canceled 5 = Completed 6 = OnHold 7 = Closed */
export enum OrderStatus {
    Draft = 1,
    Ready = 2,
    InProgress = 3,
    Canceled = 4,
    Completed = 5,
    OnHold = 6,
    Closed = 7,
}

export class CodedExceptionApi extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isCodedExceptionApi = true;

    static isCodedExceptionApi(obj: any): obj is CodedExceptionApi {
        return obj.isCodedExceptionApi === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new CodedExceptionApi(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}